
<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
	<div class="row">
	  <div class="col-12"></div>
	  <div class="col-12">
		<div class="card">
		  <div class="card-content">
			<div class="card-body">
				<div class="row">
				<div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-2">
					<div class="btn-group enrollment-list-btn-info" role="group">
					  <button id="status-btns" type="button" *ngFor="let status of status_list" class="btn text-capitalize"
						[ngClass]="{'btn-primary':activeTab==status.name,'btn-outline-primary':activeTab!=status.name}"
						(click)="activeStatusTab(0,status.name)">{{status.name}}</button>
					</div>
					
				  </div>
				  <div class="col-12 col-sm-2 col-md-2 col-lg-2 mb-2">
					<input
					  type="date"
					  class="form-control width-150"
					  (change)="changeDate()"
					  [(ngModel)]="startDate" [ngModel]="startDate | date: 'yyyy-MM-dd'" [disabled]="false"
					  id="last_activedate"
					  placeholder="Enter last active date"
					/>
					</div>
				  <h6 style="align-items: center;
				  display: flex;">To</h6>
				  <div class="col-12 col-sm-2 col-md-2 col-lg-2 mb-2">
					<input
					  type="date"
					  class="form-control width-150"
					  (change)="changeDate()"
					  [(ngModel)]="endDate" [ngModel]="endDate | date: 'yyyy-MM-dd'" [disabled]="false"
					  id="last_activedate"
					  placeholder="Enter last active date"
					/>
				  </div>
				  <div class="col-sm-2 col-md-2 col-lg-2 mb-2"></div>	
				</div>
			  <!-- ngx-datatable-filter -->
			  <fieldset class="form-group">
					<div class="row align-items-end mt-0 pagination-body row-set-line">
						
				<div class="col-12 col-sm-12 col-md-5 col-lg-5 mt-2 mb-1">
					<button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Events Guideline</button>
				</div>
					
				  <div class="col-12 col-sm-12 col-md-7 col-lg-7 mt-2 mb-1">
					<div class="row-flex">
					  <div class="col-flex-2 mb-1 position-relative">
						<input id="ngx-filter-ref"
						  class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
						  type="text" placeholder="Name|Description|Notes|Type" #name [(ngModel)]="searchVal"
						  (keydown.enter)="eventFilter(searchVal)" />
						<button class="btn search-btn glow position-absolute" (click)="eventFilter(searchVal)">
						  <i class="ft-search text-white cursor-pointer"></i>
						</button>
					  </div>
					  <div class="col-flex-2 mb-1">
						<button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">Reset
						  <i class="ft-filter text-white cursor-pointer"></i>
						</button>
					  </div>
					  <div class="col-flex-2 mb-1"
						*ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
						<button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
						  (click)="openModal2(myModal2)" placement="top" ngbTooltip="Add New">
						  +
						</button>
					  </div>
					</div>
				  </div>
				  <div class="col additional-info my-2">
					<ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
					[footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
					[count]="currentCount" [offset]="page.pageNumber" (page)="pageChangeData($event)"></ngx-datatable>
					 <!-- Additional Counts or Information -->
 <!-- Additional Counts or Information -->
 <div class=" ml-2">
    <small class="mr-2">Current Total: {{ currentStatus || 0 }}</small>
    <small class="mr-2">Future Total: {{ futureStatus || 0 }}</small>
    <small class="mr-2">Past Total: {{ pastStatus || 0 }}</small>
    <small class="mr-2">Current Count: {{ currentCount || 0 }}</small>
  </div>
				  </div>
				</div>
  
			  </fieldset>
			  <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
				[footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
				[columns]="columns" [externalPaging]="true" [count]="currentCount" [offset]="page.pageNumber"
				(page)="pageChangeData($event)">
				<ngx-datatable-column name="Name" prop="name" [width]="400">
				  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					<div class="d-flex align-items-center">
					  <!-- <img class="rounded-circle mr-1" *ngIf="row.image" [src]="imgUrl + row.image" height="38"
						width="38" /> -->
					  <div class="avatar mr-1 ml-0 bg-primary">
						<div class="avatar-content">{{ row?.name | shortName  }}</div>
						<!-- Popular "★" Badge positioned on top of avatar -->
						<span class="star-badge"
						  [ngClass]="{'popular': (row?.isPopular || 'no') === 'yes', 'not-popular': (row?.isPopular || 'no') === 'no'}"
						  title="Click to update Popular status"
						  (click)="openPopularModal(popularModal, row)"
						>
						  {{ (row?.isPopular || 'no') === 'yes' ? '★' : '☆' }}
						</span>
					  </div>

					  <!-- <div class="cell-line-height">
						<a class="line-height-1 mb-0">{{ row.categoryName }}</a>
						</div> -->
					  <div class="cell-line-height">
						<p class="font-medium-1 line-height-1 mb-0 cursor-pointer">
						  {{ row.name }}
						</p>
						<span *ngIf="row?.event_type && row?.event_type[0]?.displayname" class="badge badge-pill bg-light-secondary mt-1">{{row?.event_type[0]?.displayname}}</span>
						<!-- <span class="text-muted font-small-2">
						  Nuclear Power Engineer</span
						> -->
					  </div>
					</div>
				  </ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="Checklist" prop="checklist" [width]="60">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<p>{{row?.sprint[0]?.checklist[0]?.displayname}}</p>	
					</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="Participants" prop="participants" [width]="50">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<p class="cursor-pointer" (click)="openModalParticipants(myModal33,row)">{{row?.participants?.length}}</p>
					</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="Event Date" prop="event_date" [width]="300">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<p class="cursor-pointer">{{row?.event_date | date: 'medium'}}</p>
						<span *ngIf="row?.bussiness && row?.bussiness[0]?.name" class="badge badge-pill bg-light-danger mt-1" title="{{row?.bussiness[0]?.name}}">
							{{ row?.bussiness[0]?.name?.length > 50 ? (row?.bussiness[0]?.name | slice:0:50) + '...' : row?.bussiness[0]?.name }}
						  </span>
											  </ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="Status" prop="event_status" [width]="20">
                  
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					  <p [matMenuTriggerFor]="status">
						<span *ngIf="row?.event_status[0]?.displayname == 'Current'"
									[ngClass]="{'bg-light-success badge badge-pill':row?.event_status[0]?.displayname == 'Current'}">
									{{row?.event_status[0]?.displayname}}
								  </span>
								  <span *ngIf="row?.event_status[0]?.displayname == 'Future'"
									[ngClass]="{'bg-light-warning badge badge-pill':row?.event_status[0]?.displayname == 'Future'}">
									{{row?.event_status[0]?.displayname}}
								  </span>
								  <span *ngIf="row?.event_status[0]?.displayname == 'Past'"
									[ngClass]="{'bg-light-danger badge badge-pill':row?.event_status[0]?.displayname == 'Past'}">
									{{row?.event_status[0]?.displayname}}
								  </span>
					  </p>
					  <mat-menu #status="matMenu">
						<div *ngFor="let status of status_list">
						  <button mat-menu-item *ngIf="status?._id !== row?.event_status[0]?._id"
							(click)="updateStatus(row._id,status._id)">
							<span>
							<span [ngClass]="{'bg-light-success badge badge-pill':status.displayname == 'Current'}"
							  placement="top" *ngIf="status.displayname == 'Current'">{{status.displayname}}</span>
							<span [ngClass]="{'bg-light-warning badge badge-pill':status.displayname == 'Future'}"
							  placement="top" *ngIf="status.displayname == 'Future'">{{status.displayname}}</span>
							<span [ngClass]="{'bg-light-danger badge badge-pill':status.displayname == 'Past'}"
							  placement="top"
							  *ngIf="status.displayname == 'Past'">{{status.displayname}}</span>
							</span>
						  </button>
						  </div>
					  </mat-menu>
					  </ng-template>
				  </ngx-datatable-column>
				<ngx-datatable-column name="Actions"
				  *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
				  <ng-template let-row="row" ngx-datatable-cell-template>
					<i class="ft-edit text-primary cursor-pointer mr-2" (click)="editEvent(myModal2,row._id,row)"></i>
					<i *ngIf="user_role.roles =='admin'" class="ft-trash-2 cursor-pointer danger"
					  (click)="ConfirmColor(row._id)"></i>
					  <i class="ft-copy cursor-pointer text-primary ml-2" placement="bottom" ngbTooltip="Duplicate Event" (click)="copyEvents(row._id)"></i>
					  <i class="ft-star cursor-pointer mx-1" 
						[ngClass]="{'text-warning':(row?.isPopular || 'no') === 'yes','text-muted':(row?.isPopular || 'no') === 'no'}" 
						placement="bottom" 
						ngbTooltip="Popular Update" 
						(click)="openPopularModal(popularModal,row)"></i>

					  <div *ngIf="row?.sprint.length >0" (click)="openCheclistPopup(checklistModal,row?.sprint[0]?.data,row?.sprint[0]?._id)">
						<span class="cursor-pointer" > {{ row?.sprint[0]?.true_sprint_count}}/{{row?.sprint[0]?.sprint_count}}</span>
					  </div>
				  </ng-template>
				</ngx-datatable-column>
			  </ngx-datatable>
			  <!-- ngx-datatable-filter -->
			</div>
		  </div>
		</div>
	  </div>
	</div>
  </section>
  <!--/ Filter Datatables -->
  <div class="d-flex justify-content-between align-items-center">
	<ngx-spinner></ngx-spinner>
  </div>

  <!-------------- Check Task and Notes to Hr  Popup ------------------------------------------->
<div>
	<ng-template #myModal2 let-modal>
		<div class="modal-header">
			<h4 class="modal-title" *ngIf="!event_id">Add Event</h4>
			<h4 class="modal-title" *ngIf="event_id">Edit Event</h4>

			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<fieldset class="form-group">

				<div class="media">
					<img
					 *ngIf="img_url"
					 [src]="img_url"
					 alt="user edit avatar"
					 class="users-avatar-shadow avatar mr-3 rounded-circle"
					 height="64"
					 width="64"
				   /> 
					<img
					*ngIf="event_image && !img_url"
					 [src]="imgUrl + event_image"
					 alt="user edit avatar"
					 class="users-avatar-shadow avatar mr-3 rounded-circle"
					 height="64"
					 width="64"
				   />   
				   <!-- <div *ngIf="!courseData.image && !imgUrl"   [class.initial-alpha]="!courseData?.image">
					 <div class="avatar-content">{{courseData?.title | shortName }}</div>
				   </div>  -->
				   <div
				   *ngIf="!img_url && !event_image"
				   [class.initial-alpha]="!event_image"
				   class="users-avatar-shadow mr-1 ml-0 bg-primary"
				 >
				   <div class="avatar-content">
					 {{ event_model?.name | titlecase | shortName }}
				   </div>
				 </div>
				   <div class="media-body">
					 <h4>{{event_model?.name  | titlecase | shortName}}</h4>
					 <div
					   class="d-flex flex-sm-row flex-column justify-content-start px-0 mb-sm-2"
					 >
					 <label for="file-upload" class="btn btn-sm btn-primary mb-1 mb-sm-0 text-transform-unset">Cover Image Upload</label>
					 <input type="file"  accept="image/png, image/gif, image/jpeg" id="file-upload" (change)="onSelectFile($event)"/>
					 </div>
				   </div>
				 </div>
			</fieldset>
			<fieldset class="form-group">
				<label>Name</label>
				<input
				  type="text"
				  class="form-control"
				  [(ngModel)]="event_model.name"  
				  id="name"
				  placeholder="Enter name"
				/>
			  </fieldset>
			  <fieldset class="form-group">
				<label>Course</label>
				<ng-select
				[items]="course_list"
				bindLabel="title"
				bindValue="_id"
				placeholder="Select Course"
				[(ngModel)]="selected_course"
				[ngModelOptions]="{ standalone: true }"
				(change)="getCourseId($event)"
				>
				</ng-select>
			  </fieldset>
			  <fieldset class="form-group">
				<label>Business</label>
				<ng-select
				[items]="business_list"
				bindLabel="name"
				bindValue="_id"
				placeholder="Select Business"
				[(ngModel)]="selected_business"
				[ngModelOptions]="{ standalone: true }"
				(change)="getBusinessId($event)"
				>
				</ng-select>
			  </fieldset>
			  <fieldset class="box-field">
				<fieldset class="form-group">
					<label>Date & Time</label>
					<input
					  type="datetime-local"
					  class="form-control"
					  [(ngModel)]="event_model.event_date"   
					  id="datetime"
					  placeholder="Enter date & time" 
					/>
				</fieldset>
				<fieldset class="form-group">
					<input type="checkbox" [(ngModel)]="event_model.is_digital_certificate" [checked]="event_model.is_digital_certificate"   class="checkbox-field" (change)="digitalCertificate(event_model.is_digital_certificate)"> <label>Digital Certificate</label>
				</fieldset>
				<fieldset class="form-group">
					<input type="checkbox" [checked]="event_model.isPopular === 'yes'" class="checkbox-field" (change)="onPopularChange($event)"> <label>Is Popular</label>
				</fieldset>
			  </fieldset>
			  
			  <fieldset class="form-group">
				  <label>Location</label>
				  <input
					type="text"
					class="form-control"
					[(ngModel)]="event_model.location" 
					placeholder="Enter location"
				  />
			  </fieldset>
			  <fieldset class="form-group">
				<label>Event Organizer</label>
				<ng-select
					[items]="emp_list"
					bindLabel="name"
					bindValue="Empid"
					[closeOnSelect]="false"
					[multiple]="true"
					placeholder="Select Organizer"
					[(ngModel)]="selected_Organizer"
					[ngModelOptions]="{ standalone: true }"
					(change)="getOrganizerId($event)"
				>
				</ng-select>
			  </fieldset>
			  <fieldset class="form-group">
				<label>Event Type</label>
				<ng-select
					[items]="type_list"
					bindLabel="displayname"
					bindValue="_id"
					[closeOnSelect]="false"
					placeholder="Select Type"
					[(ngModel)]="selected_type"
					[ngModelOptions]="{ standalone: true }"
					(change)="getTypeId($event)"
				>
				</ng-select>
			  </fieldset>
			  <fieldset class="form-group" >
				<label>Checklist</label>
				<ng-select
				[items]="list_type"
				bindLabel="name"
				bindValue="_id"
				[closeOnSelect]="false"
				placeholder="Select Checklist"
				[(ngModel)]="selected_check_list"
				[ngModelOptions]="{ standalone: true }"
				(change)="getCheckListId($event)"
			  ></ng-select>
			  </fieldset>
			  <fieldset class="form-group">
				<label>Budget</label>
				<input
				  type="number"
				  class="form-control"
				  [(ngModel)]="event_model.budget" 
				  placeholder="Enter budget"
				/>
			</fieldset>
			  <fieldset class="form-group">
				<label>Capacity</label>
				<input
				  type="number"
				  class="form-control"
				  [(ngModel)]="event_model.event_capacity" 
				  placeholder="Enter capacity"
				/>
			</fieldset>
			<fieldset class="form-group">
				<label>Registration Deadline</label>
				<input
				  type="date"
				  class="form-control"
				  [(ngModel)]="event_model.registration_deadline" 
				  placeholder="Enter registration deadline"
				/>
			</fieldset>
			  <fieldset class="form-group">
				<label>Event Speakers</label>
				<ng-select
				[items]="emp_list"
				bindLabel="name"
				bindValue="Empid"
				[closeOnSelect]="false"
				[multiple]="true"
				placeholder="Select Speakers"
				[(ngModel)]="selected_Speaker"
				[ngModelOptions]="{ standalone: true }"
				(change)="getSpeakerId($event)"
				>
				</ng-select>
			  </fieldset>
			<fieldset class="form-group">
				<label>Event Description</label>
				<quill-editor (onContentChanged)="setFocus($event)" [(ngModel)]="event_model.event_tags"></quill-editor>
			</fieldset>
			<fieldset class="form-group">
				<label>Notes</label>
				<textarea
				[(ngModel)]="event_model.notes"
				  id="hidden-label-form-6"
				  rows="3"
				  class="form-control"
				  name="comment2"
				  placeholder="Enter notes"
				></textarea>
			</fieldset>
			<fieldset class="form-group">
				<label>Admin Notes</label>
				<textarea
				[(ngModel)]="event_model.admin_notes"
				  id="hidden-label-form-6"
				  rows="3"
				  class="form-control"
				  name="comment2"
				  placeholder="Enter admin notes"
				></textarea>
			</fieldset>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary" (click)="submit()">Submit</button>
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
		</div>
	</ng-template>
</div>

<!-------------- Participants List  Popup ------------------------------------------->
<div>
    <ng-template #myModal33 let-modal>
      <div class="modal-header">
        <h4 class="modal-title">Participants</h4>
        <button type="button" class="close" (click)="modal.dismiss()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table >
			<tr class="d-flex justify-content-between">
				<th>Name</th> 
				<th *ngIf="activeTab=='past'"><input type="date" [(ngModel)]="leadDump_model.next_action_date" class="form-control" style="margin-left: 120px; width: 156px;"></th>
				<th *ngIf="activeTab=='past'"><button class="btn btn-secondary mx-1" (click)="addDump()">Add</button></th>
			</tr>
			<div class="mt-1 mb-2">
				<input type="checkbox"  [(ngModel)]="selectAll" (change)="selectAllParticipants()"> Select All 
			</div>
			<tr *ngFor="let item of row_Participants; let i = index">
				<td>
					<input type="checkbox" [(ngModel)]="item.selected" [checked]="item?.participants?.is_approved == true"  (change)="updateSelectAll(item?._id)">
					{{item?.name}} 
					<span class="cursor-pointer" (click)="deleteParticipant(item?._id)"> <i class="ft-trash text-danger" ></i> </span>
					
				</td>

			</tr>
		</table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="approveParticipant()">Submit</button>
        <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
        </div>
    </ng-template>
  </div>

  <!---------- CheckList  Popup ---------------->
<div>
	<ng-template #checklistModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Checklist Update</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
      <div *ngFor="let item of key_Values; let i = index" class="key-value-input d-flex">
        <!-- <input class="input-key" type="text" placeholder="Key" [(ngModel)]="item[0]" name="key_{{i+1}}" [ngModelOptions]="{ standalone: true }"> -->
        <input class="input-value mr-1" type="checkbox" placeholder="Value" [(ngModel)]="item[1]" name="value_{{i+1}}" [ngModelOptions]="{ standalone: true }">

        <label>{{item[0]}}</label>
        
       
      </div>
    </div>
    <div class="modal-footer">
			<button type="button" class="btn btn-primary" (click)="updateCheck()">Submit</button>
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>

		  </div>
  </ng-template>
</div>

<!---------- Popular Update Modal ---------------->
<div>
  <ng-template #popularModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Popular Update</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form>
        <div class="form-group">
          <label>Is Popular</label>
          <select 
            class="form-control" 
            [(ngModel)]="popular_event"
            [ngModelOptions]="{ standalone: true }"
            (change)="selectPopular($event.target.value)"
          >
            <option value="">Select Popular Status</option>
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="submitPopular()">Submit</button>
    </div>
  </ng-template>
</div>

